<template>
  <v-menu v-if="workspaces && workspaces.length > 1" offset-y light>
    <template #activator="{ on }">
      <v-btn outlined dark v-on="on">
        <v-icon left dark :color="currentWorkspaceColor">fiber_manual_record</v-icon>
        {{ currentWorkspace.name }}
        <v-icon right dark>work_outline</v-icon>
      </v-btn>
    </template>

    <v-list light class="mt-2" style="max-height: 300px; overflow: auto">
      <v-list-item
        v-for="workspace in workspaces"
        :key="workspace.code"
        style="cursor: pointer"
        @click="changeWorkspace(workspace, route)"
      >
        <v-list-item-icon v-if="isAlpha" class="my-auto ml-0 mr-2">
          <v-icon :color="workspace.settings && workspace.settings.siteSettings && workspace.settings.siteSettings.robotsIndex ? 'green' : 'red'">fiber_manual_record</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ workspace.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { computed, provide } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';

import { changeWorkspace } from '@/utils/pwa';

const route = useRoute();
const store = useStore();

const workspaces = computed(() => store.getters.liveWorkspaces);
const currentWorkspace = computed(() => store.getters.workspace);
const isAlpha = computed(() => store.state.environment.PROJECT === 'alpha');
const currentWorkspaceColor = computed(() => {
  if (!isAlpha.value) {
    return null;
  }

  return currentWorkspace.value.settings && currentWorkspace.value.settings.siteSettings && currentWorkspace.value.settings.siteSettings.robotsIndex ? 'green' : 'red';
});

</script>

<style lang="scss" rel="stylesheet/scss">
.version-select {
  margin-top: 15px !important;
}
</style>
